import { useState } from 'react'
import Card from '../../components/card/Card';
import styles from "./auth.module.scss";
import { MdPassword } from "react-icons/md";
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { resetPassword } from '../../services/authService';


const initialState = {
    password: "",
    password2: ""
}


const Reset = () => {

    const [formData, setFormData] = useState(initialState)
    const { password, password2 } = formData
    const { resetToken } = useParams()


    const handleInputChange = (e) => {
        const { value, name } = e.target
        setFormData({ ...formData, [name]: value })
    }

    const reset = async (e) => {
        e.preventDefault()

        //Validations
        if (password.length < 6) {
            return toast.error("Password must be upto 6 characters")
        }

        if (password !== password2) {
            return toast.error("Password don't match!")
        }

        const userData = { password, password2 }

        try {
            const data = await resetPassword(userData, resetToken)
            toast.success(data.message)
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className={`container ${styles.auth}`}>
            <Card>
                <div className={styles.form}>
                    <div className="--flex-center">
                        <MdPassword size={35} color="#999" />
                    </div>
                    <h2>Reset Password</h2>
                    <form onSubmit={reset}>
                        <input type="password" placeholder='New Password' required name='password' value={password} onChange={handleInputChange} />
                        <input type="password" placeholder='Confirm New Password' required name='password2' value={password2} onChange={handleInputChange} />
                        <button type='submit' className="--btn --btn-primary --btn-block">
                            Reset Password
                        </button>
                        <span className={styles.links}>
                            <p>
                                <Link to="/">-Home</Link>
                            </p>

                            <p>
                                <Link to="/login">-Login</Link>
                            </p>
                        </span>
                    </form>

                </div>
            </Card>
        </div>
    )
}

export default Reset
